import React, { useContext, useEffect } from "react";
import FilterPopup from "../FilterPopup";
import { Button } from "semantic-ui-react";
import moment from "moment";
import { FilterContext } from "../FilterContext";
import { initialMonthFilter, MonthFilterType } from "./FilterTypes/MonthFilterType";
import { PerMonth } from "../periodfilter/periodfiltersubperiod";

const MonthFilter = () => {
  const title = RESX.DateTime.Month;

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  register("month", {
    getTitle: () => title,
    renderSelection: (filter) => <>
      {formatDate(filter.month)}
    </>,
    hasValue: (filter) => filter.month != null,
    reset: () => initialMonthFilter,
    areEqual: (a, b) => {
      if (a?.month == null && b?.month == null) return true;
      if (a?.month == null || b?.month == null) return false;
      return a?.month.startOf("month").isSame(b?.month.startOf("month"));
    }
  });
  useEffect(() => {
    setInitialValue("month", initialMonthFilter);
  }, []);

  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);
  const [filterVal, setFilterVal] = React.useState<MonthFilterType>(initialMonthFilter);
  const [apply, setApply] = React.useState<boolean>(false);

  const onPopupClose = () => {
    setPopupOpen(false);
  };

  const onPopupOpen = () => {
    const value = getValue("month");
    setFilterVal(value);
    setPopupOpen(true);
  };

  React.useEffect(() => {
    if (apply) {
      onApply();
      setApply(false);
      setPopupOpen(false);
    }
  }, [apply]);

  const onApply = (e?) => {
    e?.preventDefault();

    setValue("month", filterVal);
    setPopupOpen(false);
  };

  return <div>
    <FilterPopup
      filterButtonLabel={title}
      content={<form onSubmit={(e) => { e.preventDefault(); setApply(true); }}>
        <div className="margin-bottom">
          <PerMonth
            initialStart={filterVal.month}
            initialEnd={filterVal.month}
            onChange={m => setFilterVal({ month: m })}
          />
        </div>
        <Button fluid primary>
          {RESX.SelectionManager.Apply}
        </Button>
      </form>}
      width={400}
      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
    />
  </div>;
};

export default MonthFilter;

const formatDate = (month: moment.Moment): string => {
  return month.format("MMMM YYYY");
}